import React from "react";
import Footer from "./components/Footer";

const FooterContainer = () => {
    return <Footer />
}

export default FooterContainer;